import {
  ChangeDetectionStrategy,
  Component,
  inject,
  OnInit,
  OnDestroy,
  ChangeDetectorRef,
} from '@angular/core';
import { Router, RouterLink, NavigationEnd } from '@angular/router';
import { TuiTabBar } from '@taiga-ui/addon-mobile';
import { TranslocoService } from '@jsverse/transloco';
import { ROUTES_CONST } from '../../const/menu';
import { MenuInterface } from '../../inteface/menu';
import { filter, Subscription } from 'rxjs';
import { TranslocoDirective } from '@jsverse/transloco';

@Component({
  selector: 'app-menu',
  imports: [RouterLink, TuiTabBar, TranslocoDirective],
  templateUrl: './menu.component.html',
  styleUrl: './menu.component.less',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class MenuComponent implements OnInit, OnDestroy {
  private readonly router = inject(Router);
  private readonly cdr = inject(ChangeDetectorRef);
  private readonly translocoService = inject(TranslocoService);
  private routerSubscription: Subscription | undefined;
  ROUTES_CONST = ROUTES_CONST;
  protected activeItemIndex = 0;

  items: MenuInterface[] = [
    {
      text: '',
      icon: '@tui.flask-conical',
      link: ROUTES_CONST.START,
    },
    // {
    //   text: this.translocoService.translate('menu.tests'),
    //   icon: '@tui.book-open-check',
    //   link: ROUTES_CONST.TESTING,
    //   badge: 0,
    // },
    {
      text: '',
      icon: '@tui.graduation-cap',
      link: ROUTES_CONST.TRAINING,
    },
    {
      text: '',
      icon: '@tui.message-circle',
      link: ROUTES_CONST.EGO_CHAT,
    },
    {
      text: '',
      icon: '@tui.ticket',
      link: ROUTES_CONST.PRACTICE,
    },
    {
      text: '',
      icon: '@tui.settings',
      link: ROUTES_CONST.SETTINGS,
    },
  ];

  ngOnInit(): void {
    // Set initial active index based on current route
    this.updateActiveIndex(this.router.url);
    console.log(this.router.url);
    // Subscribe to router events to update active index
    this.routerSubscription = this.router.events
      .pipe(
        filter(
          (event): event is NavigationEnd => event instanceof NavigationEnd
        )
      )
      .subscribe((event) => {
        console.log(event);
        this.updateActiveIndex(event.url);
      });

    // Subscribe to language changes to update menu items
    this.translocoService.langChanges$.subscribe(() => {
      this.cdr.markForCheck();
    });
  }

  ngOnDestroy(): void {
    if (this.routerSubscription) {
      this.routerSubscription.unsubscribe();
    }
  }

  private updateActiveIndex(currentUrl: string): void {
    const url = currentUrl.replace('/', '');
    if (url.includes(ROUTES_CONST.PRACTICE)) {
      const practiceIndex = this.items.findIndex(
        (item) => item.link === ROUTES_CONST.PRACTICE
      );
      if (practiceIndex !== -1) {
        this.activeItemIndex = practiceIndex;
        this.cdr.markForCheck();
        return;
      }
    }
    const index = this.items.findIndex((item) => {
      if (item.link === '' && url === '') {
        return true;
      } else {
        if (item.link === '') {
          return false;
        } else {
          return url.includes(item.link);
        }
      }
    });
    if (index !== -1) {
      this.activeItemIndex = index;
      this.cdr.markForCheck();
    }
  }

  protected onClick(item: MenuInterface): void {
    item.badge = 0;
    // this.alerts.open(this.activeItemIndex, { label: item.text }).subscribe();
  }
}
